import request from '@/utils/request'
import gateway from '@/_gateway.config.js'

let { mathCustomer } = gateway

export function getMasterInfo (payOrderId) {
  return request({// /gw/math-op-web/api/op/paymentHook/doMasterAssign?payOrderId=65149972
    url: `${mathCustomer}/gw/math-op-web/api/op/paymentHook/doMasterAssign?payOrderId=${payOrderId}`,
    method: 'post'
  })
}
